import { useEffect, useState } from 'react';
import { COARSE_POINTER_QUERY } from '../utils/pointer';

/**
 * True while the primary pointer is touch.
 *
 * Starts `false` and only flips in an effect, matching `useIsMobile` — jsdom has
 * no `matchMedia`, so tests and any server render get the mouse behaviour.
 */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;

    const query = window.matchMedia(COARSE_POINTER_QUERY);
    const sync = () => setCoarse(query.matches);

    sync();

    // Plugging a mouse into a tablet changes the answer. `addListener` is the
    // deprecated spelling, and all that Safari before 14 has.
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', sync);
      return () => query.removeEventListener('change', sync);
    }

    query.addListener(sync);
    return () => query.removeListener(sync);
  }, []);

  return coarse;
}
